// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pace{-webkit-pointer-events:none;pointer-events:none;-webkit-user-select:none;user-select:none}.pace-inactive{display:none}.pace .pace-progress{background:#00b5ad;height:3px;position:fixed;right:100%;top:3.75rem;width:100%;z-index:2000}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
